export const LocalAirports = [
  "DKA",
  "ABV",
  "QUO",
  "AKR",
  "ABB",
  "BCU",
  "BNI",
  "CBQ",
  "ENU",
  "QUS",
  "IBA",
  "ILR",
  "QOW",
  "JOS",
  "KAD",
  "KAN",
  "MIU",
  "MDI",
  "LOS",
  "MXJ",
  "PHC",
  "SKO",
  "YOL",
  "ZAR",
  "GMO",
  "PHG",
  "QRW",
];
